import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Currency } from '../../models/currency.model';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ShowingCurrency } from '../../../core/models/user-profile.models';

const baseUrl: string = environment.baseUrl;


@Injectable({
    providedIn: 'root'
})

export class PaymentSharedService {
    constructor(
        private http: HttpClient
    ) { }

    getCurrencies(): Observable<Currency[]> {
        return this.http.get<Currency[]>(`${baseUrl}/finance/currency/`);
    }

    getExchangeRates(): Observable<any[]> {
        return this.http.get<any[]>(`${baseUrl}/finance/exchanges/exchange_rates/`);
    }

    setShowingCurrency(currency: ShowingCurrency): Observable<any> {
        return this.http.put(`${baseUrl}/customers/profile/`, currency);
    }
}